import * as React from 'react';
import { useEffect, useRef } from 'react';

import { Panel } from '@shared/components/bootstrap';

import { AccountCancelReasonSelector } from './account_cancel_reason_selector';

export const FinalReturnCancellationPanel: React.FC<{
  cancelable?: boolean; // True when all items are selected
  cancelReason?: string;
  setAccountCancelIntentReason?: (reason: string) => void;
  clearAccountCancelIntentReason?: () => void;
  setCancelAccount?: (value: boolean) => void;
}> = ({ cancelable, cancelReason, setAccountCancelIntentReason, clearAccountCancelIntentReason, setCancelAccount }) => {
  const prevCancelableRef = useRef<boolean | undefined>(undefined);
  const clearAccountCancelIntentReasonRef = useRef(clearAccountCancelIntentReason);
  const setCancelAccountRef = useRef(setCancelAccount);

  // Update refs when callbacks change
  useEffect(() => {
    clearAccountCancelIntentReasonRef.current = clearAccountCancelIntentReason;
    setCancelAccountRef.current = setCancelAccount;
  }, [clearAccountCancelIntentReason, setCancelAccount]);

  // Clear cancel reason and cancel_account when panel is hidden (cancelable becomes false)
  useEffect(() => {
    // When panel disappears: clear reason and set cancel_account to false
    if (prevCancelableRef.current === true && cancelable === false) {
      if (clearAccountCancelIntentReasonRef.current) {
        clearAccountCancelIntentReasonRef.current();
      }
      if (setCancelAccountRef.current) {
        setCancelAccountRef.current(false);
      }
    }
    // When panel appears: set cancel_account to true
    if (prevCancelableRef.current !== true && cancelable === true && setCancelAccountRef.current) {
      setCancelAccountRef.current(true);
    }
    prevCancelableRef.current = cancelable;
  }, [cancelable]);

  if (!cancelable || !setAccountCancelIntentReason) {
    return null;
  }

  const handleSetReason = (reason: string) => {
    setAccountCancelIntentReason(reason);
  };

  return (
    <Panel>
      <Panel.Header>
        <Panel.Title>Cancellation</Panel.Title>
      </Panel.Header>
      <Panel.Body>
        <AccountCancelReasonSelector reason={cancelReason} setReason={handleSetReason} />
      </Panel.Body>
    </Panel>
  );
};
